import { render, staticRenderFns } from "./CostUpdateModal.vue?vue&type=template&id=3565f05a&scoped=true"
import script from "./CostUpdateModal.vue?vue&type=script&lang=js"
export * from "./CostUpdateModal.vue?vue&type=script&lang=js"
import style0 from "./CostUpdateModal.vue?vue&type=style&index=0&id=3565f05a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3565f05a",
  null
  
)

export default component.exports